const typeArr = [
  { id: '', name: '' },
  { id: 'code', name: '代码类' },
  { id: 'doc', name: '文档类' },
  { id: 'portalTheme', name: '门户主题' },
  { id: 'workflowChart', name: '流程表单' },
  { id: 'workflowStyle', name: '流程表单样式' },
  { id: 'docViewTemplate', name: '文档显示模板' },
  { id: 'dataCenterApp', name: '数据中心模板' },
  { id: 'dataCenterForm', name: '数据中心报表' },
  { id: 'portalElementLib', name: '门户元素库' },
  { id: 'portalElementStyleLib', name: '门户元素样式库' },
  { id: 'mobileModeSkin', name: '移动建模皮肤' },
  { id: 'mobileModeTemplate', name: '移动建模模板' },
  { id: 'mobileModeFunction', name: '移动建模函数' },
  { id: 'mobileModeApi', name: '移动建模接口' },

];
const platArr = [
  { id: '', name: '' },
  { id: 'pc', name: 'PC' },
  { id: 'mobile', name: '移动端' },
  { id: 'all', name: '全部' },
];
export default {
  typeArr,
  platArr,
}


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/constant.js